export default __webpack_public_path__ + "static/global_challenges-b81639c3d58d9ebf5adf91e57e1675f5.png";